const checkUniqueTagName = (tags, name, id) => {
    let isNotUnique = null;
    if (id) {
        isNotUnique = tags.find((tag) => tag.name.toLowerCase() === name.toLowerCase() && tag.tag_id !== id);
    } else {
        isNotUnique = tags.find((tag) => tag.name.toLowerCase() === name.toLowerCase());
    }
    return isNotUnique ? true : false;
};

const checkUniqueZoneCategory = (categories, name, id) => {
    let isNotUnique = null;
    if (id) {
        isNotUnique = categories.find(
            (tag) => tag.display_name.toLowerCase() === name.toLowerCase() && tag.zone_category_id !== id
        );
    } else {
        isNotUnique = categories.find((tag) => tag.display_name.toLowerCase() === name.toLowerCase());
    }
    return isNotUnique ? true : false;
};

const checkUnique = (elements, elementNameKey, elementIdKey, name, id) => {
    let isNotUnique = null;
    if (id) {
        isNotUnique = elements.find(
            (element) => element[elementNameKey].toLowerCase() === name.toLowerCase() && element[elementIdKey] !== id
        );
    } else {
        isNotUnique = elements.find((element) => element[elementNameKey].toLowerCase() === name.toLowerCase());
    }
    return isNotUnique ? true : false;
};

export { checkUniqueZoneCategory, checkUniqueTagName, checkUnique };
